import { Box } from '@mui/material'
import GroupCard from 'components/groups/GroupCard'
import CustomTooltip from 'components/shared/CustomTooltip'
import { IGroupEntity } from 'models'
import moment from 'moment'
import { useAppSelector } from 'store/hooks'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

export const FoodTableIndicators = (props: IGroupEntity) => {
	const { userData } = useAppSelector(state => state.userReducer)
	const distributionWeight = Number(props.previous_distribution_weight) || 0
	const cleaningWeight = Number(props.previous_cleaning_weight) || 0
	const leftoversPercent =
		distributionWeight > 0 ? (cleaningWeight / distributionWeight) * 100 : null
	const isLeftoversAlert =
		leftoversPercent != null && (leftoversPercent <= 3 || leftoversPercent >= 6)

	const getFeedDayString = (date = new Date()) => {
		const startOfFeedDay = moment(date).hour(7).minute(0).second(0)
		if (moment(date).hour() < 7) {
			startOfFeedDay.subtract(1, 'day')
		}
		const endOfFeedDay = startOfFeedDay.clone().add(1, 'day').hour(6)
		return `За кормовой день: ${startOfFeedDay.format(
			'HH:mm DD.MM.YYYY',
		)} – ${endOfFeedDay.format('HH:mm DD.MM.YYYY')}`
	}
	return (
		<div>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'baseline',
					justifyContent: 'space-between',
					marginBottom: '16px',
				}}
			>
				<TypographyPrimary16Bold>Кормовой стол</TypographyPrimary16Bold>
				<CustomTooltip
					width={'16px'}
					height={'16px'}
					info={false}
					placement={'top'}
					title={getFeedDayString()}
				/>
			</Box>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: '1fr 1fr 1fr',
					gap: '16px',
				}}
			>
				{userData.isFoodTableExpired ? (
					<>
						<GroupCard
							bulk='Роздано корма'
							customElement={
								<TypographySecondary>Нет данных</TypographySecondary>
							}
						/>
						<GroupCard
							bulk='Остаток корма'
							customElement={
								<TypographySecondary>Нет данных</TypographySecondary>
							}
						/>
						<GroupCard
							bulk='ПСВ'
							customElement={
								<TypographySecondary>Нет данных</TypographySecondary>
							}
						/>
					</>
				) : (
					<>
						<GroupCard
							bulk='Роздано корма'
							count={props.previous_distribution_weight}
							ratio='кг'
						/>
						<GroupCard
							bulk='Остаток корма'
							count={props.previous_cleaning_weight}
							ratio='кг'
							isAlert={isLeftoversAlert}
						/>
						{props.food_dry_per_head == null ? (
							<GroupCard
								bulk='ПСВ'
								customElement={
									<TypographySecondary>Нет данных</TypographySecondary>
								}
							/>
						) : (
							<GroupCard
								bulk='ПСВ'
								count={props.food_dry_per_head}
								ratio='кг/гол'
							/>
						)}
					</>
				)}
			</Box>
		</div>
	)
}
